function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import conditionsConfig from '@/config/conditionsConfig';
import ReferenceSearchTable from '@/components/mlReferenceSearch/reference-search-table.vue';
import useCommonStore from '@/store/modules/common';
import { mapMutations } from 'vuex';
export default {
  components: {
    ReferenceSearchTable: ReferenceSearchTable
  },
  props: {
    modelValue: null,
    footer: {
      type: Boolean,
      default: false
    },
    // 实体名称兼CODE
    entityName: {
      type: [String, Number],
      default: ''
    }
  },
  data: function data() {
    return {
      // 所有类型
      op_type: {},
      // 不需要输入框的条件
      op_no_value: ['NL', 'NT', 'SFU', 'SFB', 'SFD', 'YTA', 'TDA', 'TTA', 'CUW', 'CUM', 'CUQ', 'CUY'],
      // 数组类型的字段
      numberFieldType: ['Money', 'Integer', 'Decimal', 'Percent'],
      conditionConf: {},
      fieldList: [],
      loading: false,
      fieldType: '',
      // 最多可添加多少个条件
      maxConditionsLength: 9,
      // 无效高级表达式
      errorEquation: false,
      // 所有用户
      userList: [],
      // 所有部门
      departmentList: [],
      conditionsConfig: {},
      // 条件组件
      showReferenceDialogFlag: false,
      // 格式化的实体名称
      formatEntityName: ''
    };
  },
  watch: {
    modelValue: {
      handler: function handler() {
        this.conditionConf = this.modelValue;
      },
      deep: true
    }
  },
  mounted: function mounted() {
    this.conditionConf = this.modelValue;
    this.getFieldSet();
    this.conditionsConfig = _objectSpread({}, conditionsConfig);
    this.op_type = _objectSpread({}, this.conditionsConfig.op_type);
  },
  methods: _objectSpread(_objectSpread({}, mapMutations(['queryEntityNameByCode'])), {}, {
    openReferenceDialog: function openReferenceDialog() {
      this.showReferenceDialogFlag = true;
    },
    setReferRecord: function setReferRecord(event, item) {
      item.value = event.id;
      item.value2 = event.label;
      this.showReferenceDialogFlag = false;
    },
    getFieldSet: function getFieldSet() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var entity, param, res, resUser, resDepartment, list;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.loading = true;
              entity = _this.entityName;
              if (!isNaN(entity)) {
                entity = queryEntityNameByCode(entity);
              }
              _this.formatEntityName = entity;
              // 获取条件字段接口
              param = {
                entity: entity
              };
              _context.next = 7;
              return _this.$API.common.getFieldListOfFilter(param);
            case 7:
              res = _context.sent;
              _context.next = 10;
              return _this.$API.common.getUser(param);
            case 10:
              resUser = _context.sent;
              _context.next = 13;
              return _this.$API.common.getDepartment(param);
            case 13:
              resDepartment = _context.sent;
              _this.userList = resUser ? resUser.data || [] : [];
              _this.departmentList = resDepartment ? resDepartment.data || [] : [];
              if (res) {
                list = res.data || [];
                _this.fieldList = list.map(function (el) {
                  return {
                    fieldName: el.name,
                    op: '',
                    opCom: '',
                    value: '',
                    value2: '',
                    isError: false,
                    referTo: el.referTo,
                    type: el.type,
                    label: el.label,
                    optionData: el.optionData
                  };
                });
                // 初始化已有字段
                if (_this.conditionConf.items && _this.conditionConf.items.length > 0) {
                  _this.initConditionList();
                }
              }
              _this.loading = false;
            case 18:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 初始化已有字段
    initConditionList: function initConditionList() {
      var _this2 = this;
      var conditionList = [];
      this.fieldList.forEach(function (el) {
        _this2.conditionConf.items.forEach(function (subEl) {
          if (el.fieldName === subEl.fieldName) {
            var newItem = Object.assign(_objectSpread({}, el), subEl);
            _this2.getOpCom(newItem);
            conditionList.push(newItem);
          }
        });
      });
      this.conditionConf.items = conditionList;
      // let { items, equation } = this.conditionConf;
    },
    // 字段切换
    fieldChange: function fieldChange(item) {
      var metadata = this.fieldList.filter(function (res) {
        return res.fieldName === item.fieldName;
      });
      Object.assign(item, metadata[0]);
      item.op = this.getSelectOp(item)[0];
      // 获取条件组件
      this.getOpCom(item);
    },
    // 条件组件
    getOpCom: function getOpCom(item) {
      item.opCom = this.conditionsConfig.getShowCom(item);
    },
    clearError: function clearError(item) {
      item.isError = false;
    },
    // 条件类型切换
    conditionTypeChange: function conditionTypeChange(type) {
      this.errorEquation = false;
      if (type === 1) {
        this.conditionConf.equation = '';
      } else if (type === 2) {
        this.conditionConf.equation = '1';
      } else {
        this.conditionConf.equation = '';
      }
    },
    // 获取条件op
    getSelectOp: function getSelectOp(item) {
      var type = item.type,
        referTo = item.referTo;
      var op = [];
      // 如果是引用类型
      if (type == 'Reference') {
        var referenceObj = _objectSpread({}, this.conditionsConfig[type]);
        // 有单独设定的 条件
        if (referenceObj.referenceFilters.includes(referTo)) {
          op = _toConsumableArray(referenceObj[referTo]);
        } else {
          op = _toConsumableArray(referenceObj.All);
        }
      } else {
        op = this.conditionsConfig[type] ? _toConsumableArray(this.conditionsConfig[type]) : [];
      }
      return op;
    },
    // 添加条件
    addConditions: function addConditions() {
      if (this.fieldList.length < 1) {
        this.$message.error('暂未获取到条件字段，请尝试刷新页面后重试');
        return;
      }
      if (this.conditionConf.items.length > this.maxConditionsLength - 1) {
        this.$message.warning("\u6700\u591A\u53EF\u6DFB\u52A0 ".concat(this.maxConditionsLength, " \u4E2A\u6761\u4EF6"));
        return;
      }
      var condition = this.$CloneDeep(this.fieldList[0]);
      this.fieldChange(condition);
      this.conditionConf.items.push(condition);
    },
    // 删除条件
    delConditions: function delConditions(inx) {
      this.conditionConf.items.splice(inx, 1);
    },
    // 检测条件
    checkConditionList: function checkConditionList(notNeedMsg) {
      var _this3 = this;
      var flag = true;
      if (this.conditionConf.items.length > 0) {
        this.conditionConf.items.forEach(function (el) {
          if (!el.value && el.value !== 0 && !_this3.op_no_value.includes(el.op)) {
            flag = false;
            el.isError = true;
          }
          // 区间
          if (el.op === 'BW' && (!el.value || !el.value2)) {
            flag = false;
            el.isError = true;
          }
        });
        if (!flag) {
          // 不需要提示
          if (notNeedMsg) {
            return;
          }
          this.$message.error('部分条件设置有误，请检查');
          return;
        }
      }
      return flag;
    },
    // 检测高级表达式是否成立
    checkEquation: function checkEquation() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var param, res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              param = {
                equation: _this4.conditionConf.equation
              };
              _context2.next = 3;
              return _this4.$API.common.isEquation(param);
            case 3:
              res = _context2.sent;
              _this4.errorEquation = !res;
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 确认
    confirm: function confirm() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this5$conditionConf, items, equation, type;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this5$conditionConf = _this5.conditionConf, items = _this5$conditionConf.items, equation = _this5$conditionConf.equation, type = _this5$conditionConf.type;
              if (_this5.checkConditionList()) {
                _context3.next = 3;
                break;
              }
              return _context3.abrupt("return");
            case 3:
              if (!(type === 3 && equation)) {
                _context3.next = 9;
                break;
              }
              _context3.next = 6;
              return _this5.checkEquation();
            case 6:
              if (!_this5.errorEquation) {
                _context3.next = 9;
                break;
              }
              _this5.$message.error('无效高级表达式');
              return _context3.abrupt("return");
            case 9:
              _this5.$emit('confirm', {
                equation: equation,
                items: items
              });
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    // 取消
    cancel: function cancel() {
      this.$emit('cancel');
    },
    // 获取高级表达式底纹
    getPlaceholder: function getPlaceholder() {
      var conditionList = [];
      this.conditionConf.items.forEach(function (el, inx) {
        conditionList.push(inx + 1);
      });
      return conditionList.join(' or ');
    },
    // 区间值变化
    bwChange: function bwChange(item) {
      var type = item.type;
      var defaultV1 = item.value;
      var defaultV2 = item.value2;
      var v1;
      var v2;
      // 时间区间
      if (type === 'DateTime' || type === 'Date') {
        v1 = new Date(item.value).getTime();
        v2 = new Date(item.value2).getTime();
      }
      // 数字区间
      else {
        v1 = defaultV1;
        v2 = defaultV2;
      }
      if (defaultV1 && defaultV2 && v1 > v2) {
        item.value = defaultV2;
        item.value2 = defaultV1;
      }
    }
  })
};